import { PropTypes } from "aem/ComponentWrapper";
import React from "react";

export default {
  title: "Box",
  type: "rh/components/content/box",
  isContainer: true,
  config: {
    emptyLabel: "Box",
    isEmpty: ({ children }: PropTypes) => React.Children.count(children) === 0
  }
};
